
import {
    computed,
    defineComponent,
    onMounted,
    PropType,
    ref,
    TableData,
    watch
} from 'vue'
import RoadMap from '@/components/roadmap/index.vue'
import { useListItem } from '@/composables/useListitem'
import { useStore } from '@/store'

export default defineComponent({
    components: {
        RoadMap
    },
    props: {
        activeDesk: {
            required: true,
            type: Number as PropType<number>
        },
        mData: {
            required: true,
            type: Object as PropType<TableData>
        }
    },
    setup(props) {
        let countDownInterval: boolean | number = false

        const store = useStore()

        const numRows = ref(6)

        onMounted(() => {
            numRows.value = deviceOrientation.value === 'landscape' ? 6 : 10
        })
        const {
            shoeRound,
            tableName,
            currentCount,
            timerColor,
            redPairCount,
            bluePairCount,
            greenCount,
            blueCount,
            redCount,
            limits,
            isAtThisTable,
            goodRoadName,
            enterToDesk,
            onRoadMapDataParsed,
            t
        } = useListItem(props)
        //

        const startCountDown = () => {
            if (typeof countDownInterval !== 'number') {
                currentCount.value = props.mData.expand.daoJiShiBetTime

                countDownInterval = setInterval(() => {
                    if (currentCount.value < 0) {
                        stopCountDown()
                    } else {
                        currentCount.value -= 1
                    }
                }, 1000)
            }
        }

        const stopCountDown = (): void => {
            if (typeof countDownInterval === 'number') {
                clearInterval(countDownInterval)
                countDownInterval = false
                currentCount.value = -1
            }
        }

        const deviceOrientation = computed(
            (): 'landscape' | 'portrait' => store.getters['deviceOrientation']
        )

        watch(
            () => props.mData,
            (_value) => {
                if (_value.expand.daoJiShiBetTime > 0) {
                    startCountDown()
                } else {
                    stopCountDown()
                }

                numRows.value = deviceOrientation.value === 'landscape' ? 6 : 10
            },
            { immediate: true }
        )

        return {
            numRows,
            shoeRound,
            tableName,
            currentCount,
            timerColor,
            redPairCount,
            bluePairCount,
            greenCount,
            blueCount,
            redCount,
            limits,
            isAtThisTable,
            goodRoadName,
            enterToDesk,
            onRoadMapDataParsed,
            t
        }
    }
})
